import { useCheckPermissions } from '@/shared';
import { SaveAsignaciones } from '../../shared/saveAsignaciones';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateAsignacionesPage {}

const CreateAsignacionesPage: React.FC<CreateAsignacionesPage> = () => {
  useCheckPermissions(PermissionsEnum.api_add_asignacionactivo);

  return <SaveAsignaciones titlePage="Crear Asignaciones" />;
};

export default CreateAsignacionesPage;
